import {RefObject, useLayoutEffect, useState} from 'react';

export const useIsTruncated = (elementRef: RefObject<HTMLElement | null>, dependency: unknown) => {
  const [isTruncated, setIsTruncated] = useState(false);

  useLayoutEffect(() => {
    const element = elementRef.current;

    if (!element) {
      return;
    }

    const checkTruncation = () => {
      setIsTruncated(element.scrollWidth > element.clientWidth);
    };

    const resizeObserver = new ResizeObserver(checkTruncation);
    resizeObserver.observe(element);

    checkTruncation();

    return () => {
      resizeObserver.disconnect();
    };
  }, [elementRef, dependency]);

  return isTruncated;
};
